<template>
  <div class="book">
    <div class="middle-main">
      <h1 class="title">購物清單{{ '(' + myCartListRes.length + ')' }}</h1>
      <div class="cart-list" v-if="isPc == 1">
        <!-- <el-row class="row-title">
          <el-col :span="12">
            <span>產品資訊</span>
          </el-col>
          <el-col :span="3">
            <span>單價</span>
          </el-col>
          <el-col :span="3">
            <span>數量</span>
          </el-col>
          <el-col :span="3">
            <span>小計</span>
          </el-col>
          <el-col :span="3">
            <span>刪除</span>
          </el-col>
        </el-row> -->
        <el-row class="row-list" v-for="item in myCartListRes" :key="item.id">
          <el-col :span="12">
            <div class="book-info items-center">
              <img :src="item.image[0]" class="magazine-img" />
              <div class="info">
                <h3>{{ item.title }}</h3>
                <svg-icon icon-class="pdf2" color="#fff" />

                <!-- <span>規格: <b>數位版</b></span> -->
              </div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="type">{{ L('電子版') }}</div>
          </el-col>

          <el-col :span="3">
            <div class="total-price">HK$ <em>{{ item.price }}</em></div>
          </el-col>
          <el-col :span="3">
            <div class="num">1</div>
          </el-col>
          <el-col :span="3">
            <div class="delete">
              <span @click="del(item.id)">{{ L('刪除') }}</span>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row class="btns" :gutter="15">
          <el-col :span="6">
            <div class="grid-content">清空購物清單</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">更新購物車</div>
          </el-col>
          <el-col :span="6">
            <div></div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">繼續購物</div>
          </el-col>
        </el-row> -->
      </div>
      <div class="cart-list-mobile" v-else>
        <div class="cart-list-mobile-item" v-for="item in myCartListRes" :key="item.id">
          <div class="book-info items-center">
            <img :src="item.image[0]" class="magazine-img" />
            <div class="info">
              <h3>{{ item.title }}</h3>
              <span>規格: <b>數位版</b></span>
              <span>數量: <b>1</b></span>
              <div class="price">HK$ {{ item.price }}</div>
            </div>
            <div class="delete flex-col items-center" @click="del(item.id)">
              <i class="el-icon-close"></i>
              <span>刪除</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="justify-end">
        <div class="accounts flex-col justify-between">
          <div class="justify-between items-center">
            <h3>購物車內金額</h3>
            <p>HK$ {{ total }}</p>
          </div>
          <div class="justify-between items-center">
            <h3>運費</h3>
            <p>HK$ 0</p>
          </div>
          <div class="justify-between items-center">
            <h1>應付金額</h1>
            <h2>HK$ {{ total }}</h2>
          </div>
        </div>
      </div> -->
      <div class="next-btn justify-end items-center">
        <div class="total-price"><span>{{ L('合计：') }}</span>HK$ <em>{{ total }}</em></div>
        <router-link :to="{ path: '/magazine-cart-order' }">
          <div class="next">下一步</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import swiperPolicy from "../common/swiper-policy.vue";
import ColumnTitle from "../common/column-title.vue";
import { delCart, getCart } from "@/assets/api/magazine.js";
let vm = this;

export default {
  components: {
    swiperPolicy,
    ColumnTitle,
  },
  data() {
    return {
      total: 0,
      myCartListRes: [],
    };
  },
  computed: {
    ...mapState(["isPc", "myCartList"]),
    // ...mapState({
    //   isPc: "isPc",
    //   myCartList: (state) => {
    //     console.log(state.myCartList.rows);
    //     state.myCartList.rows = state.myCartList.rows.map((item) => {
    //       item.image = item.image.split(",");
    //       item.image = item.image.map((it) => {
    //         it = !/^http/.test(it) ? "https://tsmz.ts960.com//tsMgz/" + it : it;
    //         return it;
    //       });
    //       // vm.total+=item.price
    //       return item;
    //     });
    //     return state.myCartList;
    //   },
    // }),
    // total() {
    //   let totalPrice = 0;
    //   this.myCartList.rows.map((item) => {
    //     totalPrice += item.price;
    //   });
    //   return totalPrice;
    // },
  },
  watch: {
    // myCartList(val) {
    //   this.myCartListRes = val.rows.map((item) => {
    //     item.image = item.image.split(",");
    //     item.image = item.image.map((it) => {
    //       it = !/^http/.test(it) ? this.$imgUrl + it : it;
    //       return it;
    //     });
    //     this.total += item.price;
    //     return item;
    //   });
    // console.log("this.myCartList====", this.myCartList);
    // },
  },
  created() {
    // this.$store.dispatch("getMyCart");
    this.init();
  },
  methods: {
    init() {
      getCart().then((res) => {
        if (res.data.code == 500) {
          console.log("請先登錄");
        } else {
          console.log("this.myCartList====", res.data.data);
          let totalPrice = 0;
          this.myCartListRes = res.data.data.rows.map((item) => {
            item.image = item.image.split(",");
            item.image = item.image.map((it) => {
              it = !/^http/.test(it) ? this.$imgUrl + it : it;
              return it;
            });
            totalPrice += item.price;
            return item;
          });
          this.total = totalPrice;
        }
      });
    },
    del(id) {
      delCart(id).then((res) => {
        if (res.data.code == 500) {
          console.log("請先登錄");
        } else {
          this.$message({
            message: "刪除成功",
            type: "success",
          });
          this.init();

          this.$store.dispatch("getMyCart");
          console.log(res);
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="less" scoped>
.book {
  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin: 40px 0 30px;
  }

  .row-title {
    padding: 25px 0;
    border-bottom: 1px solid #ebebeb;

    span {
      font-family: NotoSansCJKTC;
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.4;
      letter-spacing: 3.6px;
      text-align: center;
      color: #000;
    }
  }

  .row-list {
    padding: 28px 0;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    align-items: center;

    .book-info {
      .info{
        display: flex;
        align-items: center;
            svg{
              width: 78px;
              height: 32px;
              background: #E2291E;
              border-radius: 19px;
              padding: 6px 10px;
              margin-left: 12px;
            }
      }
      img {
        width: 100px;
        height: 134px;
        border-radius: 4px;
        margin-right: 20px;
      }

      h3 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #2C2C2E;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }

      span {
        font-family: NotoSansCJKTC;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: 3.6px;
        text-align: left;
        color: #959595;

        b {
          color: #000;
        }
      }
    }

    .type {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #2C2C2E;
      line-height: 19px;
      text-align: left;
      font-style: normal;
    }

    .price {
      font-family: Lato;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: italic;
      line-height: 1.87;
      letter-spacing: normal;
      color: #959595;
    }

    .num {

      .el-input-number--mini {
        width: 90px;
        height: 40px;
        line-height: 40px;
      }
    }

    .total-price {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 16px;
      color: #FF3B30;
      line-height: 21px;
      text-align: left;
      font-style: normal;

      em {
        font-size: 24px;
      }
    }

    .delete {
      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #636366;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        cursor: pointer;
      }

      span:hover {
        color: #E2291E;
      }
    }
  }

  .btns {
    margin-top: 60px;
    margin-bottom: 86px;

    div {
      height: 50px;
    }

    .grid-content {
      cursor: pointer;
      font-family: NotoSansCJKTC;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 4.2px;
      text-align: center;
      color: #e13133;
      padding: 15px 0;
      width: 100%;
      border-radius: 8px;
      border: solid 1px #e13133;
    }
  }

  .accounts {
    margin-top: 40px;
    width: 509px;
    height: 200.7px;
    padding: 41px 43px 41.7px 44px;
    background-color: #f9f9f9;
    border-radius: 8px;

    h3 {
      font-family: NotoSansCJKTC;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 24px;
      letter-spacing: 9.6px;
      text-align: left;
      color: #252525;
    }

    p {
      font-family: Lato;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      font-style: italic;
      line-height: 24px;
      letter-spacing: normal;
      text-align: right;
      color: #959595;
    }

    h1 {
      font-family: NotoSansCJKTC;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 33px;
      letter-spacing: 12px;
      text-align: left;
      color: #252525;
    }

    h2 {
      font-family: Lato;
      font-size: 27px;
      font-weight: bold;
      font-stretch: normal;
      font-style: italic;
      line-height: 33px;
      letter-spacing: normal;
      text-align: right;
      color: #000;
    }
  }

  .next {
    cursor: pointer;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 50px;
    text-align: center;
    font-style: normal;
    text-align: center;
    color: #fff;
    width: 200px;
    height: 50px;
    background: #E2291E;
    border-radius: 25px;
  }
}

.other-news {
  padding: 40px 0 80px;
  margin-top: 100px;
}

.next-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 80px;

  .total-price {
    margin-right: 30px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #FF3B30;
    line-height: 21px;
    text-align: right;
    font-style: normal;

    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #2C2C2E;
      line-height: 19px;
      text-align: right;
      font-style: normal;
    }

    em {
      font-size: 24px;
    }
  }

}

@media screen and (max-width: 768px) {
  .book {
    padding-top: 0;

    .accounts {
      margin: 40px 20px;
      width: 100%;
      height: auto;
      padding: 20px;
      background-color: #f9f9f9;
      border-radius: 8px;

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 24px;
        letter-spacing: 9.6px;
        text-align: left;
        color: #252525;
      }

      p {
        font-family: Lato;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        font-style: italic;
        line-height: 24px;
        letter-spacing: normal;
        text-align: right;
        color: #959595;
      }

      h1 {
        font-family: NotoSansCJKTC;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 33px;
        letter-spacing: 12px;
        text-align: left;
        color: #252525;
      }

      h2 {
        font-family: Lato;
        font-size: 27px;
        font-weight: bold;
        font-stretch: normal;
        font-style: italic;
        line-height: 33px;
        letter-spacing: normal;
        text-align: right;
        color: #000;
      }
    }

    .next-btn {
      justify-content: center;

    }

    .next {
      cursor: pointer;
      font-family: NotoSansCJKTC;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 4.2px;
      text-align: center;
      color: #fff;
      width: 120px;
      height: 50px;
      padding: 15px 0;
      background-color: #e13133;
      margin-top: 0;
      border-radius: 8px;
    }
  }

  .cart-list-mobile {
    padding: 0 20px;

    .cart-list-mobile-item {
      padding: 20px 0;

      .magazine-img {
        width: 80px;
        margin-right: 10px;
      }

      .info {
        display: flex;
        align-items: center;

        svg {
          width: 78px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 19px;
          border: 2px solid #E2291E;
          padding: 5px 9px;
          margin-left: 12px;
        }

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 18px;
          font-weight: 800;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.57;
          letter-spacing: 1.4px;
          text-align: left;
          color: #373a36;
        }

        span {
          font-family: NotoSansCJKTC;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: 0.6px;
          text-align: left;
          color: #8b8b8b;
        }

        .price {
          font-family: NotoSansCJKTC;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.92;
          letter-spacing: normal;
          text-align: left;
          color: #dc000c;
        }
      }
    }
  }

  .other-news {
    padding: 40px 0 80px;
    margin-top: 0;
  }
}
</style>
<style>
.num .el-input--mini .el-input__inner {
  height: 42px;
  line-height: 42px;
  font-family: Lato;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.4;
  letter-spacing: 3.3px;
  color: #000;
}

.el-input-number__decrease,
.el-input-number__increase {
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 3.9px;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/views/magazine-cart/index.vue